/* eslint-disable import/first */
import React from 'react';
import format from 'date-fns/format';
import { useNavigate } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
import { BsArrowClockwise } from '@react-icons/all-files/bs/BsArrowClockwise';

const { useSelector, useDispatch } = Redux;
import { Button } from '@material-ui/core';
const { selectBaseURL, selectCountryValidations } = Slices.configSlice;
const { postReOrder } = Slices.orderSlice;

// import { selectFirstMenu } = Slices.menuSlice;
// import { selectProductEntities } = Slices.productSlice;
// import { selectDefaultAddress } = Slices.addressSlice;
// import { sendCart } = Slices.cartSlice;
import {
  getTitleOfItems,
  decimalChecker,
  calculateTmpPrice,
} from 'spwa-ui-library/esm/utils/helper';
import noImg from '../../assets/no-itm.png';
import { FormattedMessage, useIntl } from 'react-intl';
import css from './index.module.scss';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
// const { selectFirstMenu } = Slices.menuSlice;
// const { selectProductEntities } = Slices.productSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { sendCart } = Slices.cartSlice;
const { selectPreviousOrders, selectCurrentOrders } = Slices.orderSlice;

export default function EasyOrder({ widgetData }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const orders = useSelector(selectPreviousOrders);
  const imgBaseUrl = useSelector(selectBaseURL);
  // const address = useSelector(selectDefaultAddress);
  const currentOrders = useSelector(selectCurrentOrders);
  const auth = useSelector((state) => state.auth);
  const profile = useSelector((state) => state.profile);
  const [open, setOpen] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState('');
  // const productsMap = useSelector(selectProductEntities);
  const countryValidations = useSelector((state) =>
    selectCountryValidations(state, profile.country)
  );

  // const menu = useSelector(selectFirstMenu);
  if (!auth.isLoggedIn) {
    return null;
  }
  if (!countryValidations?.enableReorder) {
    return '';
  }

  if (Array.isArray(currentOrders) && currentOrders.length > 0) {
    return null;
  }
  const reOrder = async (item) => {
    try {
      const res = await dispatch(postReOrder({ orderId: item?._id }));
      // SEND LOCAL CART
      // Check if there is an error in the response
      if (res.error) {
        setOpen(true);
        setErrMsg(res.error.message);
        // Perform additional steps or handle the error as needed
      } else {
        dispatch(sendCart.fulfilled(res?.payload));
        navigate(`/${intl.locale}/cart`);
      }
    } catch (error) {
      // Handle any network or server errors
      console.error('An error occurred:', error);
    }
  };

  const handleNavigation = (id, status) => () => {
    if (status === 'PENDING') {
      navigate(`/${intl.locale}/thank-you/` + id);
    } else {
      navigate(`/${intl.locale}/order-detail/` + id);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <div className={css.titleArea}>
        <div className={css.heading}>
          <h2 className={css.title}>{widgetData.title}</h2>
          <img src={widgetData.title_icon} alt={widgetData.title} width="18" />
        </div>
      </div>
      <section className={css.root}>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
            {errMsg}
          </Alert>
        </Snackbar>
        {orders &&
          orders.length &&
          orders.map((item, i) => {
            const imgSrc = item?.assets[0]?.src;
            const itemDetail = item?.name;
            let orderQty = item?.itemIds.length || item?.itemIdAndTypeIds?.length || item?.qty;
            if (
              countryValidations.defaultMenuTempId !== item.menuTemplateId ||
              countryValidations.defaultMenuId !== item.menuId
            ) {
              return '';
            }
            return (
              <div className={css.main} key={i}>
                <div className={css.order}>
                  <div className={css.orderMain} onClick={handleNavigation(item._id, item.status)}>
                    <div className={css.itmImg}>
                      <img
                        width="40"
                        height="40"
                        src={`${imgSrc}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = noImg;
                        }}
                        alt=""
                      />
                      <div className={css.itemStyle}>
                        <p>
                          {orderQty}
                          &nbsp;
                          {orderQty > 1 ? (
                            <FormattedMessage id="checkout_items" defaultMessage="Items" />
                          ) : (
                            <FormattedMessage id="checkout_item" defaultMessage="Item" />
                          )}
                        </p>
                      </div>
                    </div>
                    <div className={css.textBackground}>
                      {item.status !== 'PENDING' ? (
                        <>
                          <div className={css.orderBox}>
                            {item?.orderDisplayNumber ? (
                              <h5 className={css.orbNumber}>
                                <FormattedMessage
                                  id={'orderdetails_orderno'}
                                  defaultMessage="Order No"
                                />{' '}
                                <span className={css.redText}>{item?.orderDisplayNumber}</span>
                              </h5>
                            ) : null}
                          </div>
                          <p className={css.orderDateBox}>
                            {format(new Date(item.createdAt), 'dd MMM, yyyy')}
                          </p>
                          <p className={css.itemDescription}>{itemDetail}</p>
                        </>
                      ) : (
                        <h5>
                          <FormattedMessage
                            id={'currentOrder_pending'}
                            defaultMessage="Pending Confirmation"
                          />
                        </h5>
                      )}
                      {/* <h4>{format(new Date(item.createdAt), 'dd MMM, yyyy')}</h4>
                    <p>{itemDetail}</p> */}
                    </div>
                  </div>
                  <div className={css.bottomSec}>
                    <div className={css.amount}>
                      {decimalChecker(item.payment.amount)} {countryValidations?.currency}
                    </div>

                    <div className={css.button}>
                      <Button onClick={() => reOrder(item)} color="primary" variant="outlined">
                        <BsArrowClockwise className={css.styleClockIcon} />
                        <FormattedMessage
                          id="navigation_historyReOrder"
                          defaultMessage="Easy Re-order"
                        />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </section>
    </>
  );
}
